import React from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';

const PartialVendorConfigure = ({ onClose, handleYes, handleNo }) => {
  return (
    <Modal isOpen={true} centered size="md">
      <ModalHeader toggle={onClose} className="border-0 pb-0">
        <p className="fw-semibold fs-16">Partial Vendor Configure </p>
      </ModalHeader>

      <ModalBody className="pt-3">
        <p className="mb-4"> Vendor added with limited details. Complete vendor setup from the vendor manager later.</p>

        <div className="d-flex justify-content-between mb-4 gap-3">
          <Button color="white" style={{ fontSize: '14px', width: '224px', borderRadius: '5px', border: '1px solid #401589' }} onClick={handleNo}>
            No
          </Button>

          <Button color="primary" style={{ fontSize: '14px', width: '224px', borderRadius: '5px' }} onClick={handleYes}>
            Yes
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default PartialVendorConfigure;
